import { getDoctorTypeAnswer } from "containers/Survey/services/selector"
import { DoctorType } from "types/entity"
import { SurveyStore } from "types/store"

// True when the survey's selected doctor type is dermatology.
export const isDermatoDoctorType = (state: { survey: SurveyStore }): boolean =>
  getDoctorTypeAnswer(state) === DoctorType.DERMATOLOGY
